/* Scratch Theory. Two pieces of decoration, and nothing else.
   The pages read and the forms post with this file absent. */

(function () {
  'use strict';

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ticking = false;

  /* ---- Reveal on entry ---------------------------------------------------
     A pass over the whole page, not a one-shot observer. Every pass re-checks
     every block, so a jumped scroll, a resize, or a section swapped in by the
     theme editor cannot strand one at zero opacity. Anything already in view
     the first time it is seen is shown without animating.

     The CSS only hides a block once this file has armed it, so if the script
     never runs the page is simply the page. */

  function revealPass() {
    var line = (window.innerHeight || 0) * 0.9;

    document.querySelectorAll('[data-reveal]:not([data-armed])').forEach(function (el) {
      el.setAttribute('data-armed', '');
      if (el.getBoundingClientRect().top < line) el.setAttribute('data-shown', '');
    });

    document.querySelectorAll('[data-reveal][data-armed]:not([data-shown])').forEach(function (el) {
      if (el.getBoundingClientRect().top < line) el.setAttribute('data-shown', '');
    });
  }

  /* ---- Drift figures against the scroll -------------------------------- */

  var DRIFT_LIMIT = 72;

  function driftPass() {
    var viewport = window.innerHeight || 0;

    document.querySelectorAll('[data-drift]').forEach(function (el) {
      var strength = parseFloat(el.getAttribute('data-drift')) || 0;
      var current = parseFloat((el.style.translate || '0 0').split(' ')[1]) || 0;
      var box = el.getBoundingClientRect();
      var distance = box.top + box.height / 2 - current - viewport / 2;
      var offset = Math.round(distance * strength);
      /* Far off screen the raw offset grows without bound, and a figure can
         end up painted over the block above it. Hold it to a drift. */
      offset = Math.max(-DRIFT_LIMIT, Math.min(DRIFT_LIMIT, offset));
      el.style.translate = '0 ' + offset + 'px';
    });
  }

  function pass() {
    revealPass();
    driftPass();
    ticking = false;
  }

  function request() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(pass);
  }

  function start() {
    if (reduced) return;

    pass();
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request, { passive: true });
    window.addEventListener('load', request);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* The theme editor tears sections down and rebuilds them. */
  document.addEventListener('shopify:section:load', function () {
    if (!reduced) request();
  });
})();
